export var Colors = {
    primary: "#e55a00",
    accent: "#c52845",
};
